import React, { useState, useRef } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import Swal from "sweetalert2";
import "../pages/inquiry.css";
import { sendOtp } from "../api/sendOtp";

const MobileInput = ({
  phoneNumber,
  countryCode,
  onChange,
  defaultCountry = "in",
  className,
  onOtpVerified,
}) => {
  const [showOtpInputs, setShowOtpInputs] = useState(false);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [loading, setLoading] = useState(false);
  const otpRefs = useRef([]);

  const handleOtpChange = (index, val) => {
    const newVal = val.slice(-1);
    const updatedOtp = [...otp];
    updatedOtp[index] = newVal;
    setOtp(updatedOtp);

    // Forward focus
    if (newVal && index < otp.length - 1) {
      otpRefs.current[index + 1].focus();
    }

    // Check if OTP is complete
    if (updatedOtp.every((digit) => digit !== "")) {
      onOtpVerified(updatedOtp.join(""));
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      if (!otp[index] && index > 0) {
        otpRefs.current[index - 1].focus();
      }
    }
  };

  const handleSendOtp = async () => {
    if (!phoneNumber) {
      Swal.fire({
        title: "Error",
        html: "<p style='font-weight: bold;'>Please enter your phone number before requesting OTP.</p>",
        icon: "error",
      });
      return;
    }

    setLoading(true); // Show loader

    const data = {
      Phone: phoneNumber,
      Country: countryCode,
    };

    try {
      // const response = await fetch(
      //   "https://erp.suryamanisolar.com/api/sendOTP",
      //   {
      //     method: "POST",
      //     headers: {
      //       "Content-Type": "application/json",
      //     },
      //     body: JSON.stringify(data),
      //   }
      // );

      // const result = await response.json();

      const result = await sendOtp(data);

      if (result.success) {
        setShowOtpInputs(true);
        Swal.fire({
          title: "OTP Sent!",
          html: "<p style='font-weight: bold;'>We have sent you an OTP. Please check your phone.</p>",
          icon: "success",
        });
      } else {
        Swal.fire({
          title: "Error",
          text: result.message || "Failed to send OTP. Please try again.",
          icon: "error",
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: "Something went wrong. Please try again later.",
        icon: "error",
      });
    } finally {
      setLoading(false); // Hide loader
    }
  };

  return (
    <div className="position-relative w-100">
      <div className="position-relative">
        <PhoneInput
          country={defaultCountry}
          phoneNumber={phoneNumber}
          onChange={onChange}
          inputClass={`${className} custom-mobile-input`}
          containerClass="w-100"
          onlyCountries={["in", "gb", "us", "au", "ca", "ae", "sg", "tz", "ke"]}
        />

        <button
          type="button"
          className="btn-sm fw-semibold position-absolute verify-otp-btn"
          style={{
            top: "50%",
            right: "10px",
            transform: "translateY(-50%)",
            zIndex: 10,
            padding: "6px 14px",
            fontSize: "0.85rem",
            border: "2px solid #007bff",
            color: loading ? "#fff" : "#007bff",
            backgroundColor: loading ? "#007bff" : "#fff",
            borderRadius: "20px",
            boxShadow: "0 2px 6px rgba(0, 0, 0, 0.05)",
            transition: "all 0.3s ease",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "5px",
            cursor: loading ? "not-allowed" : "pointer",
            opacity: loading ? 0.85 : 1,
            minWidth: "100px", // to prevent button shrink on loading
          }}
          onClick={handleSendOtp}
          disabled={loading}
          onMouseEnter={(e) => {
            if (!loading) {
              e.currentTarget.style.backgroundColor = "#007bff";
              e.currentTarget.style.color = "#fff";
            }
          }}
          onMouseLeave={(e) => {
            if (!loading) {
              e.currentTarget.style.backgroundColor = "#fff";
              e.currentTarget.style.color = "#007bff";
            }
          }}
        >
          {loading ? (
            <div
              className="spinner-border spinner-border-sm text-light"
              role="status"
              style={{ width: "1rem", height: "1rem" }}
            />
          ) : (
            "Verify OTP"
          )}
        </button>
      </div>

      {showOtpInputs && (
        <div
          className="d-flex justify-content-between gap-2 mt-2"
          style={{ width: "100%" }}
        >
          {otp.map((digit, index) => (
            <input
              key={index}
              type="tel"
              maxLength="1"
              className="form-control text-center otp-box"
              style={{
                flex: 1,
                minWidth: "0",
                fontWeight: "bold",
                padding: "10px 0",
              }}
              value={digit}
              onChange={(e) => handleOtpChange(index, e.target.value)}
              onKeyDown={(e) => handleKeyDown(e, index)}
              ref={(el) => (otpRefs.current[index] = el)}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default MobileInput;
